import ServicePageTemplate from '@/pages/services/components/ServicePageTemplate';
import { financeOperations } from '@/mocks/servicePages';
import FinReconciliation from './components/FinReconciliation';

export default function FinanceOperationsPage() {
  return <ServicePageTemplate data={financeOperations} system={<FinReconciliation />} />;
}